import { createContext } from "react"

export const SmartHomeContext = createContext();